import { useTranslation } from "react-i18next";
import IconAutocomplete, { stringOptionsWithIcon } from "../../../../components/forms/IconAutocomplete";

type AnomalyCategoryFiltersProps = {
  categoryOptions: string[];
  subCategoryOptions: string[];
  selectedCategory: string | null;
  selectedSubCategory: string | null;
  onCategoryChange: (value: string | null) => void;
  onSubCategoryChange: (value: string | null) => void;
  loading?: boolean;
};

const AnomalyCategoryFilters = ({
  categoryOptions,
  subCategoryOptions,
  selectedCategory,
  selectedSubCategory,
  onCategoryChange,
  onSubCategoryChange,
  loading = false,
}: AnomalyCategoryFiltersProps) => {
  const { t } = useTranslation();

  return (
    <>
      <IconAutocomplete
        options={stringOptionsWithIcon(categoryOptions, "category")}
        value={selectedCategory}
        onChange={onCategoryChange}
        loading={loading}
        label={t("anomalies.category")}
        placeholder={t("anomalies.selectCategory")}
      />
      <IconAutocomplete
        options={stringOptionsWithIcon(subCategoryOptions, "subdirectory_arrow_right")}
        value={selectedSubCategory}
        onChange={onSubCategoryChange}
        loading={loading}
        disabled={!selectedCategory}
        label={t("anomalies.subcategory")}
        placeholder={
          selectedCategory ? t("anomalies.form.searchSubcategory") : t("anomalies.selectCategoryFirst")
        }
      />
    </>
  );
};

export default AnomalyCategoryFilters;
